import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withFieldProps } from 'hooks/useFieldProps';
import RawHtml from 'common/RawHtml';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import ErrorMsg from 'common/ErrorMsg';

const styles = ({ spacing, typography }) => ({
  error: {
    color: 'red',
  },
  root: {
    '& .amount': {
      ...typography.h4,
      display: 'block',
      textAlign: 'center',
    },
    '& label': {
      ...typography.h2,
      display: 'block',
      textAlign: 'center',
    },
    margin: [spacing.md, 0],
  },
});

const OutputFunding = ({
  classes,
  name,
  newValue,
  onChange,
  totalAmountFieldLabel,
  validate,
  value,
}) => {
  useEffect(() => {
    if (newValue !== value) {
      onChange(name, newValue);
      validate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, newValue, value]);
  return (
    <>
      <div className={classnames('total', classes.root)}>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <RawHtml type="label" className="totalFundingAmount">
          {totalAmountFieldLabel}
        </RawHtml>
        <div className="amount">
          {Number(value).toLocaleString('en-US', {
            currency: 'USD',
            style: 'currency',
          })}
        </div>
      </div>
      <ErrorMsg name={name} style={{ display: 'block', width: '100%' }} center />
    </>
  );
};

OutputFunding.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  name: PropTypes.string.isRequired,
  newValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  totalAmountFieldLabel: PropTypes.string.isRequired,
  validate: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

const mapStateToProps = ({ data, fields, resources }) => ({
  newValue: Object.keys(fields).reduce((total, key) => {
    if (fields[key].fieldType === 'AMOUNT_SELECTOR') {
      const val = Number(String(data[key]).replace(/,/g, ''));
      if (!Number.isNaN(val)) {
        return total + val;
      }
    }
    return total;
  }, 0),
  totalAmountFieldLabel: resources.totalAmountFieldLabel ?? '',
});

const OutputFundingStyled = withStyles(styles)(OutputFunding);

export default withFieldProps(mapStateToProps)(OutputFundingStyled);
